import { Event, type EventTradeResolution } from '@kalos/kalos-rpc';
import { RpcError } from '@protobuf-ts/runtime-rpc';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { EventClientService } from '../../tools/helpers';
import { queryKeys } from './constants';

export type ResolveEventTradeFilter = {
  departmentId: number;
  jobTypeId: number;
  jobSubtypeId: number;
  isResidential: number;
};

export const useResolveEventTradeQuery = ({
  departmentId,
  jobTypeId,
  jobSubtypeId,
  isResidential,
}: ResolveEventTradeFilter) => {
  return useQuery({
    queryKey: [
      queryKeys.eventTradeResolution.root,
      departmentId,
      jobTypeId,
      jobSubtypeId,
      isResidential,
    ],
    queryFn: async (): Promise<EventTradeResolution | null> => {
      try {
        return await EventClientService.ResolveEventTrade(
          Event.create({ departmentId, jobTypeId, jobSubtypeId, isResidential }),
        );
      } catch (err) {
        // Backend without the RPC yet: no resolution, callers fall back to the department rule.
        if (err instanceof RpcError && err.code === 'UNIMPLEMENTED') return null;
        throw err;
      }
    },
    enabled: departmentId > 0,
    staleTime: 60 * 1000,
    // Keep the last answer while a new Sub Type resolves so the TRADE badge does not blink.
    placeholderData: keepPreviousData,
  });
};
